import React from "react";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    margin: "20px",
  },
  header: {
    fontSize: "larger",
    fontWeight: "bold",
  },
  subheader: {
    fontWeight: "bold",
    display: "block",
    color: "#3c32d2",
    marginTop: "40px",
    marginBottom: "20px",
  },
}));

function PrivacyPolicy() {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <Typography className={classes.header}>Privacy Policy</Typography>
      <p>
        <Typography component="h4" className={classes.subheader}>
          Introduction
        </Typography>
        <p>
          The protection of personal information is important to Hi-Flyer Food
          (Canada), Inc. and we have a policy and procedures dealing with the
          protection of privacy. Any questions about this policy can be directed
          to our Privacy Officer, Francis Victorino at
          francis.victorino@hiflyer.ca
        </p>
        <p>
          Our operations extend throughout Canada and we are therefore required
          to comply with various regional and federal statues governing the
          privacy of personal information. We are committed to privacy and have
          developed this single policy but recognize that there may be slight
          variations in its application across the company as a result of the
          differences in statutes governing the privacy of personal information.
        </p>
        <p>
          Our employees play an important role in protecting personal
          information. Our employees are required to adhere to this policy and
          take all reasonable steps to ensure that personal information is
          protected from unauthorized use, access and disclosure.
        </p>
      </p>
      <p>
        <Typography component="h4" className={classes.subheader}>
          Collection, Use and Disclosure of Personal Information
        </Typography>
        <p>
          We collect personal information from our customers in order to
          administer the contract for products and/or services. We collect the
          following types of personal information from our customers:
          <ul>
            <li>Customer name;</li>
            <li>Customer address and telephone number;</li>
            <li>Customer order details</li>
          </ul>
        </p>
        <p>
          This personal information is collected for the following purposes:
          <ul>
            <li>
              To fulfill delivery and order ahead and pick up orders from kfc.ca
              or the KFC Canada delivery phone number
            </li>
            <li>
              To contact the customer for instruction and billing purposes
            </li>
            <li>For the administration of the contract for services</li>
            <li>
              To contact the customer for updates on their delivery/takeout
              orders
            </li>
          </ul>
        </p>
        <p>
          We only use a customer’s personal information for the purposes
          outlined above. If we need to use the personal information for any
          other purpose, we will contact the customer and obtain consent prior
          to that use.
        </p>
        <p>
          We disclose customers’ personal information to the following third
          parties:
          <ul>
            <li>Store delivery drivers</li>
          </ul>
        </p>
        <p>
          We disclose this information in order to fulfill delivery services,
          provide additional instructions, get clarifications for billing
          purposes and provide order updates to our customers. We do not
          disclose personal information to third parties for any other purposes.
        </p>
        <p>
          Our customers have the right to withdraw consent for our collection,
          use or disclosure of their personal information at any time. However,
          if a customer does so it may affect his/ her ability to avail of the
          KFC Canada delivery and order ahead and pick up services. If a
          customer wishes to withdraw consent, or has any questions about
          withdrawing consent, he or she can contact our Privacy Officer.
        </p>
      </p>
      <p>
        <Typography component="h4" className={classes.subheader}>
          Consent
        </Typography>
        <p>
          In most cases customers consent to us collecting, using and disclosing
          personal information for the purposes outlined above by simply
          agreeing to provide us with the personal information.
        </p>
      </p>
      <p>
        <Typography component="h4" className={classes.subheader}>
          Storing your Personal Information
        </Typography>
        <p>
          We only keep personal information for as long as is necessary for the
          purposes outlined above. This may include keeping the information
          after a project is completed in order to resolve any problems or
          concerns that may arise. We are also required by law to maintain
          certain records for set amounts of time. We have appropriate
          safeguards in place to protect personal information and when we no
          longer need the information it is destroyed. We try to keep personal
          information as accurate as possible and customers can assist us by
          providing us with updated information when necessary. Information can
          be updated by contacting Francis Victorino at
          francis.victorino@hiflyer.ca.
        </p>
      </p>
      <p>
        <Typography component="h4" className={classes.subheader}>
          Access
        </Typography>
        <p>
          Our customers have the right to access the personal information we
          hold about them. A customer can access his/her personal information by
          making a request to our Privacy Officer. The Officer will provide the
          necessary forms and assistance to make the request and obtain the
          information. If the customer believes that some of the personal
          information is incorrect, he or she can request that the information
          be corrected.
        </p>
        <p>
          We may charge our customers for out-of-pocket expenses in responding
          to an access request. If we decide that a charge is appropriate, we
          will provide the customer with a written estimate prior to providing
          access. Any concerns with the estimated charge should be directed to
          our Privacy Officer.
        </p>
      </p>
      <p>
        <Typography component="h4" className={classes.subheader}>
          Accountability
        </Typography>
        <p>
          We apply our best efforts to protect our customer’s privacy. If our
          customers have any concerns, they are free to contact our Privacy
          Officer. We hope that the Officer will be able to resolve any
          problems. If concerns are not resolved, the Officer can provide
          information on making a formal complaint.
        </p>
      </p>
    </div>
  );
}

export default PrivacyPolicy;
